export const snackbarStyles = theme => ({
    snackbar: {
        backgroundColor: theme.palette.darkBlueGray,
        textAlign: 'center',
        height: '64px'
      },
      container:{
          display: 'flex',
          width: '430px',
          justifyContent: 'space-between'
      },
      svg:{
          margin: '0vw 1vw',
          cursor: 'pointer'
      }
})
